import { ICategoryPageMatch } from "@faire/deprecated-retailer-visitor-shared/categories/ICategoryPageMatch";
import {
  BRAND_VALUE_FILTER_TYPE,
  buildFilterKey,
} from "@faire/deprecated-retailer-visitor-shared/filters/filterKeys";
import { splitFiltersFromQueryParams } from "@faire/deprecated-retailer-visitor-shared/filters/splitFiltersFromQueryParams";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";
import { route as c1Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import { route as c1RouteBrandValue } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/brand-value/brandValue";
import { route as c2Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId";
import { route as c2RouteBrandValue } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/brand-value/brandValue";
import { route as c3Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId";
import { route as c3RouteBrandValue } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/brand-value/brandValue";
import { route as c4Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId";
import { route as c5Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId/c5CategoryUrlId";
import { route as c6Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId/c5CategoryUrlId/c6CategoryUrlId";
import { RawQueryParams } from "@faire/web/common/query-params/QueryParams";
import { RetailerRoute } from "@faire/web/common/routes/RetailerRouteMatcher";
import { RouteMatcher } from "@faire/web/common/routes/RouteMatcher";
import { isEnumKey } from "@faire/web/common/typescriptUtils";

import SearchRequestReferrerType = ISearchRequestReferrer.SearchRequestReferrerType;

export const categoryRouteMatcher = new RouteMatcher<RetailerRoute>([
  c1Route,
  c1RouteBrandValue,
  c2Route,
  c2RouteBrandValue,
  c3Route,
  c3RouteBrandValue,
  c4Route,
  c5Route,
  c6Route,
]);

const CATEGORY_BRAND_VALUE_ROUTES = [
  c1RouteBrandValue,
  c2RouteBrandValue,
  c3RouteBrandValue,
];

export const getCategoryRouteMatches = (
  route: RetailerRoute,
  match: string[]
): ICategoryPageMatch => {
  let categoryParams: string[] = [];
  const response: ICategoryPageMatch = {};

  if (CATEGORY_BRAND_VALUE_ROUTES.includes(route)) {
    categoryParams = match.slice(1, -1);
    response.brandValue = decodeURIComponent(match.pop() ?? "");
  } else {
    categoryParams = match.slice(1);
  }

  const [
    c1CategoryUrlId,
    c2CategoryUrlId,
    c3CategoryUrlId,
    c4CategoryUrlId,
    c5CategoryUrlId,
    c6CategoryUrlId,
  ] = categoryParams;

  return {
    ...response,
    c1CategoryUrlId,
    c2CategoryUrlId,
    c3CategoryUrlId,
    c4CategoryUrlId,
    c5CategoryUrlId,
    c6CategoryUrlId,
  };
};

export const getPageNumberGivenRecordOfQueryParams = (
  parsedSearch: RawQueryParams
): number => {
  const page = parsedSearch.get("page");
  if (page) {
    return Array.isArray(page) ? parseInt(page[0], 10) : parseInt(page, 10);
  } else {
    return 1;
  }
};

export const getFilterKeysGivenRecordOfQueryParams = (
  parsedSearch: RawQueryParams
): string[] => {
  const filterKeys = splitFiltersFromQueryParams(parsedSearch) ?? [];
  return filterKeys.map(decodeURIComponent).sort();
};

export const getFilterKeysWithBrandValue = (
  filterKeysFromQueryParams: string[],
  brandValueMatch?: string
) => {
  const brandValueFilterValue = brandValueMatch?.replace(/-/g, "_");

  if (brandValueFilterValue) {
    const brandValueFilterKey = buildFilterKey(
      BRAND_VALUE_FILTER_TYPE,
      brandValueFilterValue
    );
    if (!filterKeysFromQueryParams.includes(brandValueFilterKey)) {
      return [brandValueFilterKey, ...filterKeysFromQueryParams];
    }
  }
  return filterKeysFromQueryParams;
};

export const getRequestReferrer = (parsedSearch: RawQueryParams) => {
  const referrerTypeParsedSearch =
    parsedSearch.get("refType") ?? SearchRequestReferrerType.NONE;

  const validRefType = isEnumKey(
    SearchRequestReferrerType,
    referrerTypeParsedSearch
  )
    ? referrerTypeParsedSearch
    : SearchRequestReferrerType.NONE;

  const refReqId = parsedSearch.get("refReqId");

  return ISearchRequestReferrer.build({
    referrer_type: SearchRequestReferrerType[validRefType],
    referrer_request_id: refReqId ?? undefined,
  });
};
